import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface productSkeletonProps {
  count?: number;
  className?: string;
}

const ProductSkeleton: React.FC<productSkeletonProps> = ({ count = 3, className = "" }) => {
  return (
    <section className="py-8 px-3 md:px-4">
      <div className="container mx-auto px-0 max-w-6xl">
        <div
          className={cn(
            "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6",
            className
          )}
        >
          {Array.from({ length: count }).map((_, index) => (
            <div
              key={index}
              className="relative bg-gradient-to-br from-white to-[#F1F0FB]/40 rounded-lg  flex flex-col items-center shadow-sm border hover:translate-y-[-2px] transition-transform duration-300"
            >
              <div className="w-full flex justify-center mb-4 ">
                <Skeleton className="md:h-52 h-32 w-full bg-slate-400 rounded-b-none" />
              </div>

              <div className="w-full flex justify-start mb-2 px-4">
                <Skeleton className="h-4 w-32 bg-slate-300" />
              </div>

              <div className="w-full flex justify-start px-4 mb-4">
                <Skeleton className="h-3 w-52 bg-slate-200" />
              </div>

              <div className="w-full flex justify-between mb-2 ">
                <div className="w-full flex justify-start items-center mb-2 px-4">
                  <Skeleton className="h-5 w-12 bg-slate-300" />
                </div>

                <div className="w-full flex justify-end mb-2 px-4">
                  <Skeleton className="h-8 w-16 bg-slate-300" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSkeleton;
